export class MessageConfig {

    constructor() {
        this.messageLib = {};
    }

    public messageLib: object;

    public setErrorMessage(vType: string, message: string) {
        this.messageLib[vType] = message;
    }

    public $get() {
        let _service: any = {};

        _service.messageLib = this.messageLib;

        _service.setErrorMessage = this.setErrorMessage;

        return _service;
    }
}